<template>
    <div>
        <router-link :to="`#${anchor || 'Hero'}End`" 
            class="hero__scrolldown d-none d-sm-block">
            <fa-icon :icon="['fal', 'angle-down']" size="2x"></fa-icon>
        </router-link>
        <div :id="`${anchor || 'Hero'}End`" class="hero__end"></div>
    </div>
</template>
<script>
export default {
    props: ['anchor']
}
</script>
